import React, { useState, useEffect, useCallback } from 'react';
import useTakeOrderValidation from './useTakeOrderValidation';
import { Button } from 'aha-components';
import ModalAnalysisBreadcrumb from '../ModalAnalysisBreadcrumb';
import AudienceDemographics from './audienceDemographics';
import AnalysisContent from './AnalysisContent';
import PriceContent from './PriceContent';
import { AudienceViewSource, SelfEstimatedStatus } from './config';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { useTranslation } from 'react-i18next';
import { scrollElementToTop } from '@/utils/scrollElementToTop';

interface Props {}

// 接单流程 移动端弹窗内容

const MobileConst: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();
  const { audienceView } = detailData || {};
  const [{ step, hasVisitedRateStep }, setFlow] = useState({
    step: 1,
    hasVisitedRateStep: false
  });
  const setStep = useCallback((nextStep: number) => {
    setFlow((previous) => ({
      step: nextStep,
      hasVisitedRateStep: previous.hasVisitedRateStep || nextStep === 2
    }));
  }, []);
  const {
    thisLoading,
    showModalTakeOrder,
    setShowModalTakeOrder,
    takeOrderAudienceView
  } = useWebModalStore();
  const [isPriceValid, setIsPriceValid] = useState(true);
  const currentAudienceView = takeOrderAudienceView ?? audienceView;
  const hasAudienceData =
    currentAudienceView?.source === AudienceViewSource.FIRST_PARTY ||
    (currentAudienceView?.source === AudienceViewSource.SELF_ESTIMATED &&
      currentAudienceView?.status === SelfEstimatedStatus.SUCCESS);
  const [audienceError, setAudienceError] = useState(false); // 判断是否报错
  const [selectCountryError, setSelectCountryError] = useState(false); // 判断是否选择国家

  const [scheduleError, setScheduleError] = useState(false);
  const validate = useTakeOrderValidation({
    isPriceValid,
    setSelectCountryError,
    setAudienceError,
    setScheduleError
  });

  useEffect(() => {
    if (!showModalTakeOrder) {
      setScheduleError(false);
      setSelectCountryError(false);
      setAudienceError(false);
    }
  }, [showModalTakeOrder]);

  useEffect(() => {
    // // 是一方平台数据；或者是自研数据 并且数据已经准备好；并且不是本次上传截图的信息，则跳到步骤2,
    if (
      (audienceView?.source === AudienceViewSource.FIRST_PARTY ||
        (audienceView?.status === SelfEstimatedStatus.SUCCESS &&
          audienceView?.source === AudienceViewSource.SELF_ESTIMATED)) &&
      !thisLoading
    ) {
      setStep(2);
    } else {
      setStep(1);
    }
  }, [audienceView]);

  const mobileStickyFooterClassName =
    'bg-white w-full fixed bottom-0 left-0 right-0 z-[1301] flex gap-2 border-t border-solid border-[#e8e8ec] px-4 pt-4 pb-[calc(16px+env(safe-area-inset-bottom,0px))]';
  const mobileStepContentClassName =
    'pb-[calc(88px+env(safe-area-inset-bottom,0px))]';

  return (
    <>
      {/* 步骤 */}
      <ModalAnalysisBreadcrumb index={step - 1} />

      {/* 步骤内容 */}
      <div className="mt-4">
        {step === 1 && (
          <>
            {/* 步骤1 */}
            <div className={mobileStepContentClassName}>
              <AudienceDemographics
                audienceError={audienceError}
                setAudienceError={setAudienceError}
              />
            </div>
            <div className={mobileStickyFooterClassName}>
              <Button
                className="flex-1"
                onClick={() => setShowModalTakeOrder(false)}
              >
                <span>
                  {t('general_text.cancel', {
                    defaultValue: 'Cancel'
                  })}
                </span>
              </Button>
              <Button
                type="primary"
                className="flex-1"
                onClick={() => {
                  if (hasAudienceData) {
                    setAudienceError(false);
                    setStep(step + 1);
                  } else {
                    setAudienceError(true);
                    scrollElementToTop('take-order-audience-demographics');
                  }
                }}
              >
                <span>
                  {t('general_text.continue', {
                    defaultValue: 'Continue'
                  })}
                </span>
              </Button>
            </div>
          </>
        )}
        {/* 首次进入后保留表单实例，返回时不重新初始化报价和固定报价开关。 */}
        {hasVisitedRateStep && (
          <div hidden={step !== 2} className={mobileStepContentClassName}>
            <AnalysisContent
              selectCountryError={selectCountryError}
              setSelectCountryError={setSelectCountryError}
              onPriceValidChange={setIsPriceValid}
              scheduleError={scheduleError}
            />
          </div>
        )}
        {step === 2 && (
          <>
            {/* 步骤2 */}
            <div className={mobileStickyFooterClassName}>
              <Button className="flex-1" onClick={() => setStep(1)}>
                <span>
                  {t('general_text.back', {
                    defaultValue: 'Back'
                  })}
                </span>
              </Button>
              <Button
                type="primary"
                className="flex-1"
                onClick={() => {
                  if (validate(false)) setStep(3);
                }}
              >
                <span>
                  {t('general_text.continue', {
                    defaultValue: 'Continue'
                  })}
                </span>
              </Button>
            </div>
          </>
        )}
        {step === 3 && (
          <>
            {/* 步骤3 */}
            <PriceContent
              setSelectCountryError={setSelectCountryError}
              setAudienceError={setAudienceError}
              setScheduleError={setScheduleError}
              onValidationError={setStep}
              isPriceValid={isPriceValid}
              step={step}
              setStep={setStep}
            />
          </>
        )}
      </div>
    </>
  );
};

export default MobileConst;
